import { useCallback, useEffect, useRef, useState } from 'react';
const measureImpUsingOffsets = ref => {
  try {
    if (ref.current) {
      const element = ref.current;
      const newMeasurements = {
        width: Math.floor(element.offsetWidth),
        height: Math.floor(element.offsetHeight),
        top: Math.floor(element.offsetTop),
        left: Math.floor(element.offsetLeft)
      };
      return newMeasurements;
    } else {
      throw new Error('ref.current is null');
    }
  } catch (e) {
    console.error('could not get measurements for ', ref, e);
    return {
      width: 0,
      height: 0,
      top: 0,
      left: 0
    };
  }
};
export const useMeasure = _ref => {
  let {
    callback,
    index,
    ref,
    allowMeasuring = true // Default value
  } = _ref;
  const [currentMeasurements, setCurrentMeasurements] = useState(null);
  const debounceTimeout = useRef(undefined);
  const measure = useCallback(() => {
    if (!allowMeasuring) {
      return;
    } // Check if measuring is allowed

    const newMeasurements = measureImpUsingOffsets(ref);
    if (!currentMeasurements || newMeasurements.width !== currentMeasurements.width || newMeasurements.height !== currentMeasurements.height || newMeasurements.top !== currentMeasurements.top || newMeasurements.left !== currentMeasurements.left) {
      setCurrentMeasurements(newMeasurements);
      callback(newMeasurements, index);
    }
  }, [allowMeasuring, callback, currentMeasurements, index, ref]);
  useEffect(() => {
    const handleEvents = () => {
      if (!allowMeasuring) {
        return;
      } // Check if measuring is allowed

      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = window.setTimeout(() => {
        window.setTimeout(measure, 0);
      }, 50);
    };
    const resizeObserver = new ResizeObserver(handleEvents);
    const intersectionObserver = new IntersectionObserver(handleEvents);
    if (ref.current) {
      resizeObserver.observe(ref.current);
      intersectionObserver.observe(ref.current);
    }
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      if (ref.current) {
        resizeObserver.unobserve(ref.current);
        intersectionObserver.unobserve(ref.current);
      }
    };
  }, [allowMeasuring, measure, ref]);
};
//# sourceMappingURL=useMeasure.js.map